import { render, staticRenderFns } from "./TransferenciasPropias.vue?vue&type=template&id=bc971b02&scoped=true"
import script from "./TransferenciasPropias.vue?vue&type=script&lang=ts"
export * from "./TransferenciasPropias.vue?vue&type=script&lang=ts"
import style0 from "./TransferenciasPropias.vue?vue&type=style&index=0&id=bc971b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc971b02",
  null
  
)

export default component.exports